// extracted by mini-css-extract-plugin
export default {"footer":"BundleLimitPopup_footer","buttonClose":"BundleLimitPopup_buttonClose"};